import { Typography } from "@mui/material";
import React from "react";

const BugDescriptionFormat = (description) => {
  const lines = description.split("\n");

  // Regular expression to identify lines that are headings (end with `:`)
  const headingPattern = /^\*?\s*([\w\s-]+)\s*:\*?$/; // Matches normal and bold headings

  return lines.map((line, index) => {
    const trimmedLine = line.trim(); // Remove spaces around the line

    // Check if the line matches the heading pattern (bold or normal heading)
    const match = trimmedLine.match(headingPattern);
    if (match) {
      // Extract the clean heading text
      const headingText = match[1].trim();

      return (
        <Typography
          key={index}
          variant="body2"
          component="p"
          sx={{ fontWeight: "normal" }}
        >
          {headingText}
        </Typography>
      );
    }

    // If the line starts with a number (like 1.), preserve it
    if (/^\d+\./.test(trimmedLine)) {
      return (
        <Typography key={index} variant="body2" component="p">
          {trimmedLine}
        </Typography>
      );
    }

    // Preserve list items correctly (starting with `* ` or `- `)
    if (/^\*\s+|^-+\s+/.test(trimmedLine)) {
      return (
        <Typography key={index} variant="body2" component="p">
          {trimmedLine.replace(/^\*\s*/, "• ")}{" "}
          {/* Convert `*` to bullet points */}
        </Typography>
      );
    }

    // General text (normal content)
    return (
      <Typography key={index} variant="body2" component="p">
        {trimmedLine}
      </Typography>
    );
  });
};

export default BugDescriptionFormat;
